import { createSlotRecipeContext, type HTMLChakraProps } from '@chakra-ui/react'

import { formLayoutRecipe } from '@/theme/recipes/form-layout.recipe'

const { withProvider, withContext } = createSlotRecipeContext({ recipe: formLayoutRecipe })

const FormLayoutRoot = withProvider<HTMLDivElement, HTMLChakraProps<'div'>>('div', 'root')
const FormLayoutSection = withContext<HTMLElement, HTMLChakraProps<'section'>>(
  'section',
  'section'
)
const FormLayoutFields = withContext<HTMLDivElement, HTMLChakraProps<'div'>>('div', 'fields')
const FormLayoutActions = withContext<HTMLDivElement, HTMLChakraProps<'div'>>('div', 'actions')
const FormLayoutTitle = withContext<HTMLHeadingElement, HTMLChakraProps<'h2'>>('h2', 'title')
const FormLayoutDescription = withContext<HTMLParagraphElement, HTMLChakraProps<'p'>>(
  'p',
  'description'
)

export const FormLayout = {
  Root: FormLayoutRoot,
  Section: FormLayoutSection,
  Fields: FormLayoutFields,
  Actions: FormLayoutActions,
  Title: FormLayoutTitle,
  Description: FormLayoutDescription,
}
